/**
 * Centralized "current signed-in user's email" projection. Wraps
 * `useMedplumProfile()` and normalizes the email (trim + lowercase)
 * through `@benchmark/core/feature-flags` so every call site agrees
 * on the canonical shape.
 *
 * @agentic connections
 */

import { useMedplumProfile } from "@medplum/react";
import type { Practitioner } from "@medplum/fhirtypes";
import { normalizeEmail } from "@benchmark/core/feature-flags";

/**
 * Returns the signed-in Medplum profile's email, normalized via
 * `normalizeEmail`. Returns `undefined` when there's no profile, no
 * email telecom entry, or the entry is empty/whitespace-only.
 * @agentic connections
 */
export const useUserEmail = (): string | undefined => {
  const profile = useMedplumProfile() as Practitioner | undefined;
  const raw = profile?.telecom?.find((t) => t.system === "email")?.value;
  return normalizeEmail(raw) ?? undefined;
};
